import { InfoDisplayField } from './InfoDisplayField';
import { useFirstPaymentPeriodField } from './hooks/useFirstPaymentPeriodField';

export const FirstPaymentPeriodField = () => {
    const { label, value } = useFirstPaymentPeriodField();

    return <InfoDisplayField label={label} value={value} />;
};
